import { useContext } from "react";

import { ObserveSaleOrderLineBySaleOrder } from "../../../../database/helpers/sale_order_line";
import { getSaleOrderByIdObserve } from "./../../../../database/helpers/sale_order";
import withObservables from "@nozbe/with-observables";
import { LanguageContext } from "../../../../context/LanguageContext";
import { HeadingText, ParagraphText } from "../../../../Libraries";
import {
  SummaryList,
  TotalSummaryCard,
  TwoColumnWrapperHeader,
  twoColumnWrapperHeaderStyles,
} from "../../../common";
import useOrderSummary from "../../../../hooks/useOrderSummary";
import styles from "./styles.module.css";
import { Box } from "@mui/material";
import { NoteIcon } from "../../../../assets/icons/icon";

const SaleOrderSummary = ({
  sale_order_line,
  calculateTotalAmountOrder,
  sale_order,
}) => {
  const [I18n] = useContext(LanguageContext);

  const { subTotalAmount, totalDiscountPerItem } = useOrderSummary({
    sale_order_line,
    orderDiscount: sale_order[0]?._raw?.discount,
    orderDiscountMethod: sale_order[0]?._raw?.discount_unit,
    orderTax: sale_order[0]?._raw?.tax,
    orderTaxMethod: sale_order[0]?._raw?.tax_type,
  });

  return (
    <Box className={styles.container}>
      <TwoColumnWrapperHeader>
        <Box className={twoColumnWrapperHeaderStyles.left}>
          <HeadingText className={"fontSize18 fontWeight500 newFontColor"}>
            {I18n.order_summary}
          </HeadingText>
        </Box>
        <Box className={twoColumnWrapperHeaderStyles.right}></Box>
      </TwoColumnWrapperHeader>

      <Box className={styles.summaryListWrapper}>
        <Box className={styles.headerRow} role="row">
          <Box className={styles.thCell} component="div" role="columnheader">
            <ParagraphText className="fontSize12 fontWeight500 newLightColor">
              {I18n.item_name}
            </ParagraphText>
          </Box>
          <Box
            className={`${styles.thCell}`}
            component="div"
            role="columnheader"
          >
            <ParagraphText className="fontSize12 fontWeight500 newLightColor">
              {I18n.qty}
            </ParagraphText>
          </Box>
          <Box
            className={`${styles.thCell}`}
            component="div"
            role="columnheader"
          >
            <ParagraphText className="fontSize12 fontWeight500 newLightColor">
              {I18n.amount}
            </ParagraphText>
          </Box>
        </Box>
        <SummaryList itemList={sale_order_line} />
      </Box>

      {sale_order[0]?._raw?.note && (
        <Box className={styles.noteRow}>
          <NoteIcon />
          <ParagraphText className={styles.noteText} id="note_id">
            {sale_order[0]?._raw?.note}
          </ParagraphText>
        </Box>
      )}

      <Box className={styles.amountBox}>
        <TotalSummaryCard
          subTotal={subTotalAmount - totalDiscountPerItem}
          discount={sale_order[0]?._raw?.discount}
          discountMethod={sale_order[0]?._raw?.discount_unit ?? "rs"}
          totalDiscountPerItem={totalDiscountPerItem}
          note={sale_order[0]?._raw?.note ?? ""}
          tax={sale_order[0]?._raw?.tax}
          calculateTotalAmountOrder={calculateTotalAmountOrder}
        />
      </Box>
    </Box>
  );
};

const enhance = withObservables(
  ["activeSaleOrder", "sale_order_line", "sale_order"],
  ({ activeSaleOrder }) => {
    return {
      sale_order_line: ObserveSaleOrderLineBySaleOrder(
        activeSaleOrder?.id ?? "",
      ),
      sale_order: getSaleOrderByIdObserve(activeSaleOrder?.id ?? ""),
    };
  },
);

export default enhance(SaleOrderSummary);
